import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const userObj = useSelector(state => state.userDetails); 
  const [open, setOpen] = React.useState(false); 

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>No Authorization</h3></div>
                  <p>
                      <h1 style={{textAlign:'center',color:'#FF0000'}}>You are not authorized for this module.</h1>
                      <h4 style={{textAlign:'center'}}>Go to Other Page</h4>
                      <Box mt={2}>

                      {userObj.navigation?userObj.navigation.map((myRow,index)=>(
                          <Button key={'b'+index} onClick={() => {window.location.href='/'+myRow.url}} style={{margin:5}} size="small" variant="outlined" >{myRow.label}</Button>
                      )):null}  

								      </Box>
                     
                  </p>  
            </Grid>
          </DialogContent>
      </Dialog>
      

    </>
  );

});

export default CustomizedDialogs;